// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBase: 'https://api.ekviratech.com/api',
  XApiKey: 'pgH7QzFHJx4w46fI~5Uzi4RvtTwlEXp',
  siteKey: "6LdIILIlAAAAAEBvypwOT73xU9kVx05OOWtBdwP2",
  phone: "+27 731015002",
  location: "40 Polo Fields, Morningside, Sandton, South Africa",
  email: "HR@Microsynctechnologies.com",
  username: "Application",
  password: "App@2023",
  TenantName: "SaraIndiaTech",
  TenantId: "funetyiwn4tu5bs4rubw56"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
